import { render, staticRenderFns } from "./TherapistDashModalLock.vue?vue&type=template&id=69590ec0&scoped=true"
import script from "./TherapistDashModalLock.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69590ec0",
  null
  
)

export default component.exports